export interface Permissions {
    action: string;
    permission: string;
    key: string;
}
